<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>confirmation_number</mat-icon></div>
          <mat-card-title>
            Ticket
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando ticket...</p>

        <mat-card *ngIf="formulario && !carregando">
          <app-ticket-cadastro
            [formulario]="formulario"
            [segmentos]="segmentos"
            [parceiros]="parceiros"
            [atribuicoes]="atribuicoes"
            [uploadedFiles]="uploadedFiles"
            [isDragOver]="isDragOver"
            [tempoEstimadoBloqueadoPersistido]="tempoEstimadoBloqueado"
            [compararCampos]="compararCampos"
            (definirDataPrevisao)="definirDataPrevisaoEntrega()"
            (limpar)="limparFormulario()"
            (selecionarArquivos)="selecionarArquivos($event)"
            (soltarArquivos)="soltarArquivos($event)"
            (arrastarSobre)="arrastarSobre($event)"
            (sairDoArrasto)="sairDoArrasto($event)"
            (removerArquivo)="removerArquivo($event)"
            (baixarArquivo)="baixarArquivo($event)">
          </app-ticket-cadastro>

          <div class="tempo-demanda">
            <div class="tempo-demanda__titulo">
              <mat-icon>timer</mat-icon> Tempo da demanda
            </div>

            <div class="tempo-demanda__corpo">
              <div class="tempo-demanda__cronometro" [class.tempo-demanda__cronometro--ativo]="cronometroAtivo"
                   [class.tempo-demanda__cronometro--excedido]="excedeuEstimativa">
                <span class="tempo-demanda__label">Tempo gasto</span>
                <span class="tempo-demanda__valor">{{ tempoGastoFormatado }}</span>
                <span class="tempo-demanda__sub" *ngIf="tempoEstimadoFormatado !== '—'">
                  de {{ tempoEstimadoFormatado }} estimado
                  <span *ngIf="excedeuEstimativa" class="tempo-demanda__alerta">(excedido)</span>
                </span>
              </div>

              <div class="tempo-demanda__acoes">
                <button type="button" mat-raised-button color="primary"
                        *ngIf="!cronometroAtivo" (click)="iniciarCronometro()" [disabled]="!ticketId">
                  <mat-icon>play_arrow</mat-icon> Iniciar demanda
                </button>
                <button type="button" mat-raised-button color="warn"
                        *ngIf="cronometroAtivo" (click)="pararCronometro()">
                  <mat-icon>pause</mat-icon> Parar
                </button>
                <span class="tempo-demanda__dica" *ngIf="!ticketId">Salve o ticket para contar o tempo.</span>
              </div>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" mat-stroked-button color="accent" *ngIf="formulario?.get('id')?.value"
                    (click)="abrirAlteracao()">
              <mat-icon>edit</mat-icon> Alterar dados
            </button>
            <button type="button" mat-raised-button color="primary" (click)="submit()">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
        </mat-card>
      </mat-card>
    </div>

    <div class="mat-elevation-z8 mt-4" *ngIf="formulario?.get('id')?.value">
      <app-ticket-comentarios
        [formulario]="formulario"
        [comentarios]="comentarios"
        [loading]="loading"
        [lastPage]="lastPage"
        [novoComentario]="novoComentario"
        (novoComentarioChange)="novoComentario = $event"
        [imagensSelecionadas]="imagensSelecionadas"
        (adicionarComentario)="adicionarComentario()"
        (carregarMais)="carregarMaisComentarios()"
        (arquivoSelecionado)="onFileSelected($event)"
        (removerImagem)="removerImagem($event)">
      </app-ticket-comentarios>
    </div>
  </div>
</main>

<ng-template #dialogAlteracao>
  <h2 mat-dialog-title>Alterar dado do ticket</h2>
  <mat-dialog-content class="alteracao-dialog">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>O que deseja alterar?</mat-label>
      <mat-select [(ngModel)]="alteracaoCampo">
        <mat-option *ngFor="let c of camposAlteraveis" [value]="c.id">{{ c.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width" *ngIf="alteracaoCampo === 'STATUS'">
      <mat-label>Novo status</mat-label>
      <mat-select [(ngModel)]="alteracaoStatus">
        <mat-option *ngFor="let s of statusLista" [value]="s">{{ descStatus(s) }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width" *ngIf="alteracaoCampo === 'CATEGORIA'">
      <mat-label>Nova categoria</mat-label>
      <mat-select [(ngModel)]="alteracaoCategoria">
        <mat-option *ngFor="let t of tipoLista" [value]="t">{{ descTipo(t) }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width" *ngIf="alteracaoCampo === 'PREVISAO'">
      <mat-label>Nova previsão de entrega</mat-label>
      <input matInput [matDatepicker]="pickerAlt" [(ngModel)]="alteracaoPrevisao">
      <mat-datepicker-toggle matSuffix [for]="pickerAlt"></mat-datepicker-toggle>
      <mat-datepicker #pickerAlt></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width" *ngIf="alteracaoCampo === 'RESPONSAVEL'">
      <mat-label>Novo responsável</mat-label>
      <mat-select [(ngModel)]="alteracaoResponsavel" [compareWith]="compararCampos">
        <mat-option *ngFor="let a of atribuicoes" [value]="a">{{ a.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Motivo da alteração</mat-label>
      <textarea matInput [(ngModel)]="alteracaoMotivo" rows="3" required></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancelar</button>
    <button mat-raised-button color="primary" (click)="confirmarAlteracao()" [disabled]="salvandoAlteracao">
      <mat-icon>check</mat-icon> Confirmar
    </button>
  </mat-dialog-actions>
</ng-template>
